function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{fill:none;stroke:unset;stroke-miterlimit:10;stroke-width:2.6px;}.cls-2{stroke-miterlimit:10;stroke-width:2.6px;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M40.5,57.13H12.55c-1.27,0-2.31-.74-2.31-1.65v-46c0-.91,1-1.65,2.31-1.65h39.9c1.28,0,2.31.74,2.31,1.65V47.59Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("line", {
  className: "cls-2",
  x1: 17.72,
  y1: 18.5,
  x2: 47.28,
  y2: 18.5
});

var _ref5 =
/*#__PURE__*/
React.createElement("line", {
  className: "cls-2",
  x1: 17.72,
  y1: 24.54,
  x2: 47.28,
  y2: 24.54
});

var _ref6 =
/*#__PURE__*/
React.createElement("line", {
  className: "cls-2",
  x1: 17.72,
  y1: 30.59,
  x2: 47.28,
  y2: 30.59
});

var _ref7 =
/*#__PURE__*/
React.createElement("line", {
  className: "cls-2",
  x1: 17.72,
  y1: 36.63,
  x2: 47.28,
  y2: 36.63
});

var _ref8 =
/*#__PURE__*/
React.createElement("line", {
  className: "cls-2",
  x1: 17.72,
  y1: 42.68,
  x2: 47.28,
  y2: 42.68
});

var SvgRecommends = function SvgRecommends(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 65 65",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRecommends, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/recommends.8cfe57fc.svg";
export { ForwardRef as ReactComponent };